import React, { useMemo } from 'react';
import { Box } from '@tapresearch/ui/components';
import { ResponsiveBump } from '@nivo/bump';
import { formatBumpChartData } from './formatBumpChartData';
import { Serie } from '@nivo/line';
import { useColorScheme } from './useColorScheme';

export interface ResponsiveBumpChartProps {
  data: Serie[];
}

export function ResponsiveBumpChart({ data }: ResponsiveBumpChartProps) {
  const formattedData = useMemo(() => {
    return formatBumpChartData(data);
  }, [data]);
  const chartColors = useColorScheme();

  return (
    <Box height="400px">
      <ResponsiveBump
        data={formattedData}
        colors={chartColors}
        lineWidth={3}
        activeLineWidth={6}
        inactiveLineWidth={3}
        inactiveOpacity={0.15}
        pointSize={10}
        activePointSize={16}
        inactivePointSize={0}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={3}
        activePointBorderWidth={3}
        pointBorderColor={{ from: 'serie.color' }}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: '',
          legendPosition: 'middle',
          legendOffset: 32,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Rank Order',
          legendPosition: 'middle',
          legendOffset: -50,
        }}
        margin={{ top: 40, right: 150, bottom: 40, left: 80 }}
      />
    </Box>
  );
}
